var contabilidadReporteisnOpcionesSchema = {
  empresas: {
    id: 'number',
  },
}

function ContabilidadReporteisnOpciones ($http) {
  this.get = function () {
    return $http.get('/api/empresa/reporte/isn/opciones', {
      cache: 'contabilidad',
      schema: contabilidadReporteisnOpcionesSchema,
    })
  }
}

angular.module('contabilidad.reporteisn')
  .service('ContabilidadReporteisnOpciones', ContabilidadReporteisnOpciones)



// WEBPACK FOOTER //
// ./src/contabilidad/reporteisn/services/ReporteisnOpciones.js